import { weekdayKeys } from "../../lib/schedule-time/schedule-dates";
import Konva from "konva";
import type { ArtMetadata } from "../../lib/schedule-presets/art-metadata";
import { attachMetadataDrag, moveMetadataElement } from "./metadata-drag";
import { snapMetadataNode } from "./metadata-snapping";
import { layoutCanvasPoint } from "../../lib/schedule-art/layout-coordinates";
import type { BuilderDayLayout } from "../../lib/metadata-builder/day-layouts";
import type { MetadataDay } from "../../lib/metadata-history/metadata-targets";

export function renderOriginMarkers(group: Konva.Group, metadata: ArtMetadata | null, layout?: BuilderDayLayout, previewDays?: MetadataDay[] | null) {
  group.destroyChildren();
  if (!metadata) return;
  weekdayKeys.forEach((key, index) => {
    const day = metadata.days[key];
    if (!day) return;
    if (previewDays && !previewDays.includes(key)) return;
    const anchor = layout?.anchors[key] ?? day.origin;
    const marker = new Konva.Group({ x: anchor[0], y: anchor[1], draggable: true });
    marker.setAttrs({ metadataPath: `days.${key}.origin`, metadataDay: key, metadataOrigin: [0, 0] });
    const moveChildren = () => {
      const textGroup = group.getParent()?.findOne<Konva.Group>(".metadata-text");
      textGroup?.getChildren().forEach(node => {
        if (!(node instanceof Konva.Group)) return;
        if (node.getAttr("metadataDay") !== key) return;
        if (layout && !String(node.getAttr("metadataPath")).startsWith(`days.${key}.${layout.mode}.`)) return;
        const offset = node.getAttr("metadataOffset") as number[];
        const origin = layout ? day.origin : [marker.x(), marker.y()];
        const point = layoutCanvasPoint(offset, origin, day.rotation);
        if (layout) {
          point[0] = point[0]! + marker.x() - anchor[0]!;
          point[1] = point[1]! + marker.y() - anchor[1]!;
        }
        node.position({ x: point[0]!, y: point[1]! });
      });
    };
    attachMetadataDrag(marker, `days.${key}.origin`, [0, 0], moveMetadataElement, event => {
      marker.position({ x: Math.round(marker.x()), y: Math.round(marker.y()) });
      moveChildren();
      snapMetadataNode(marker, [0, 0], event.evt.altKey);
      moveChildren();
    });
    marker.add(new Konva.Rect({
      width: 36, height: 36, fill: "#dc2626", stroke: "#ffffff", strokeWidth: 2,
    }));
    marker.add(new Konva.Text({
      text: String(index + 1), width: 36, height: 36,
      align: "center", verticalAlign: "middle", fontFamily: "Arial",
      fontSize: 26, fontStyle: "bold", fill: "#ffffff",
    }));
    group.add(marker);
  });
}
